import React from 'react';
import './AppTopbar.css';

export const AppTopbar = (props) => {
    return (
        <div className="layout-topbar clearfix">
            <button
                type="button"
                className=" layout-menu-button menu-link"
                onClick={props.onToggleMenu}
            >
                <div className={`menu-btn ${props.isSidebarVisible ? 'open' : ''}`}>
                    <div className="menu-burger"></div>
                </div>
            </button>
        </div>
    );
};
